<!--
  Port of legacy `efile/efileElements/data.html`. The toolbar mirrors the
  ui-router parent state `submissions-dasboard.submission.data` (efile.js
  L130) where each tab swaps a sibling sub-state into the nested ui-view.
  Today the parent (`submission-detail.html`) projects the matching
  Angular component into <ng-content>, so the visual hierarchy stays
  identical: tab strip on top, screen body underneath.
-->
<!--
  Legacy `data.html` tab row: [expand] … [Data][PDF][Overrides][XML] only.
  Plus + form search live on `addEdit.html` `.card-header.form-card` (L445–450),
  implemented in `gtw-efile-add-edit` `.tile-grid-header`.
-->
<div class="efile-data-rail">
  <ul class="nav nav-tabs efile-data-tab-strip" role="presentation">
    <li class="tool-bar tool-bar--leading" role="none">
      <button
        type="button"
        class="efile-tab-expand-btn"
        (click)="expandView()"
        title="Expand editor / restore form list"
        aria-label="Expand editor or restore form list">
        <i class="fa fa-expand" aria-hidden="true"></i>
      </button>
    </li>
    <li class="nav-tabs-spacer" aria-hidden="true"></li>
    <!-- Segmented toggles (legacy submission Data view): one cluster, Data…XML -->
    <li class="nav-item efile-data-tabs-cluster" role="presentation">
      <div class="efile-data-tab-group" role="tablist" aria-label="E-file data views">
        @for (tab of visibleTabs; track $index) {
<a
         
          class="nav-link efile-data-tab-link"
          role="tab"
          [attr.aria-selected]="tab.key === activeTab"
          [class.active]="tab.key === activeTab"
          (click)="selectTab(tab)"
        >
          @if (tab.key === 'pdf') {

            <span class="efile-data-tab-label">{{ tab.label }}</span>
          
} @else {
{{ tab.label }}
}
          
        </a>
}
      </div>
    </li>
  </ul>
  <div class="view-animate tab-container">
    <div class="tab-content-shell">
      <ng-content></ng-content>
    </div>
  </div>
</div>
